module.exports = __webpack_public_path__ + "v.no1.72d6a891.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/v.no1.jpg
// module id = xj9z
// module chunks = 0